<template>
  <div class="pie_chart_button" @click="openModal">
    <div class="button_icon"></div>
  </div>
</template>

<script>
export default {
  name: 'PieChartButton',
  emits: ['open-modal'],
  methods: {
    openModal() {
      this.$emit('open-modal')
    },
  },
}
</script>

<style scoped>
.pie_chart_button {
  border-radius: 8px;
  height: 37px;
  width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s ease;
  margin-top: 4px;
}

.pie_chart_button:hover {
  opacity: 0.7;
}

.button_icon {
  width: 24px;
  height: 24px;
  background-image: url('/pie_chart_icon.svg');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  filter: var(--icon-filter);
}
</style>
